import(/* webpackMode: "eager" */ "/usr/src/app/apps/web/src/app/global-error.js");
